export default __webpack_public_path__ + "static/media/home-6.83952069.jpg";